import {
    liveCheckItineraryAction,
} from 'wanderu-ducks-live-check';

import { selectors as tripSelectors } from '../../../appstate/trips';

function liveCheckItinerary(tripIds, opts) {
    return (dispatch, getState) => {
        const lcCtx = tripSelectors.selectLiveCheckContext(getState(), tripIds);
        const lcOpts = {
            ...opts,
            ...lcCtx,
        };

        dispatch(liveCheckItineraryAction.liveCheckItinerary(tripIds, lcOpts));
    };
}

function refreshLiveCheckItinerary(tripIds, opts) {
    return (dispatch) => {
        dispatch(liveCheckItineraryAction.resetLiveCheckItinerary(tripIds, opts));
        dispatch(liveCheckItinerary(tripIds, opts));
    };
}

export {
    liveCheckItinerary,
    refreshLiveCheckItinerary,
};
